// @ts-check

export class AssetService {
  constructor(manifest = { assets: {}, fallbacks: {} }) {
    this.manifest = manifest;
  }
  entry(key) {
    const value = this.manifest.assets?.[key];
    if (
      !value ||
      typeof value.url !== "string" ||
      !value.url.startsWith("./generated/") ||
      value.url.includes("..")
    )
      return null;
    return value;
  }
  poster(id, overrides = {}) {
    return (
      this.entry(
        overrides.poster_id
          ? `entity/${overrides.poster_id}/poster`
          : `entity/${id}/poster`,
      ) ?? { url: this.manifest.fallbacks?.poster }
    );
  }
  thumbnail(id, overrides = {}) {
    return (
      this.entry(
        overrides.poster_id
          ? `entity/${overrides.poster_id}/thumbnail`
          : `entity/${id}/thumbnail`,
      ) ?? this.poster(id, overrides)
    );
  }
  video(id, overrides = {}) {
    return this.entry(
      overrides.video_id
        ? `entity/${overrides.video_id}/video`
        : `entity/${id}/video`,
    );
  }
  packCover(id) {
    return (
      this.entry(`pack/${id}/cover`) ?? { url: this.manifest.fallbacks?.poster }
    );
  }
  portrait(id) {
    return this.entry(`character/${id}/portrait`);
  }
  voice(lineId) {
    return this.entry(`voice/${lineId}/default`);
  }
  music(themeId, explicitId, currentUrl = null) {
    return (
      this.entry(`theme/${explicitId ?? themeId}/music`) ??
      (currentUrl ? { url: currentUrl } : null) ??
      this.entry("theme/base_bgm/music")
    );
  }
  sfx(id) {
    return this.entry(`sfx/${id}/default`);
  }
}
